export const supportedLocales = ['ru', 'en'];

export const ruCustomToolRequestFormLink =
  window.toolboxConfig.ru_custom_tool_request_form_link ||
  'https://nextgis.ru/contact/';

export const enCustomToolRequestFormLink =
  window.toolboxConfig.en_custom_tool_request_form_link ||
  'https://nextgis.com/contact/';
